import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'genericFunctionFilter'
})
export class GenericFunctionFilterPipe implements PipeTransform {

  transform(elements: any[], filterOptions: FilterOptions): any[] {
    if (!elements) {
      return null;
    }

    let filtered = elements;
    if (filterOptions.filterFns) {
      filterOptions.filterFns.forEach(fn => {
        filtered = filtered.filter(fn);
      })
    }

    if (filterOptions.sortFn && filtered) {
      filtered.sort(filterOptions.sortFn);
    }

    if (filterOptions.resultFn) {
      filterOptions.resultFn(filtered);
    }


    return filtered;
  }

}

export interface FilterOptions {
  pipeForcedAt?: Date
  sortFn?: (a, b) => number;
  filterFns?: ((element: any, value: any) => boolean)[];
  resultFn?: (filtered) => void;
}
